export const EQUIPMENT_TYPES_LIST = [
	{ name: 'Van', id: 'b738a0d4-a03d-4302-8f57-2aa1f3eb2f9b' },
	{ name: 'Reefer', id: '836284b0-f1ae-4f78-83e6-93f81b4c22c9' },
	{ name: 'Flatbed', id: '59693058-3268-4827-b5cc-4eac370c8188' },
	{ name: 'Double Drop', id: '02d36318-37fb-4967-85cf-d49b65758bc8' },
	{ name: 'Power', id: 'e9ced401-93d9-4bc9-9342-d020481133dc' },
	{ name: 'StepDeck', id: '09090c04-c19d-4ef2-8cae-605d69105494' },
	{ name: 'Tanker', id: '689e53ba-f44f-4702-8db4-9f706018fc56' },
	{ name: 'Removable Gooseneck', id: '86bdf40d-539f-4e70-90a2-c5471f2604c3' },
	{ name: 'Container', id: '42a8e1cf-c85b-4357-b229-a09c163b72f7' },
	{ name: 'Box', id: 'f5d9ac97-c088-473f-9ed1-f77548f6aeb1' },
	{ name: 'Sprinter', id: '31d9c357-54a7-4df7-8bc6-d197c6e938a4' },
];
